<div class="dashboard-page container-page">
    <div class="title-page d-flex justify-content-between">
        <div class="title">
            DANH SÁCH ĐỐI TÁC
        </div>
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="col-sm-12 d-flex justify-content-center flex-wrap">
                        <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="errorMessage !== undefined && errorMessage.length > 0" v-for="(error, key) in errorMessage" :key="error">
                            <span>{{error}}</span>
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeError(key)">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <div class="search-partner-component d-flex flex-wrap">
                        <div class="search-box col-sm-12 d-flex justify-content-between flex-wrap">
                            <div class="list-search col-sm-11 d-flex flex-column">
                                <div class="col-sm-12 d-flex gap-5 flex-wrap">
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.name_partner.label"
                                                :id="dataSearch.name_partner.id"
                                                :placeholder="dataSearch.name_partner.placeholder"
                                                :value-default="dataSearch.name_partner.value"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.code_partner.label"
                                                :id="dataSearch.code_partner.id"
                                                :placeholder="dataSearch.code_partner.placeholder"
                                                :value-default="dataSearch.code_partner.value"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.email_partner.label"
                                                :id="dataSearch.email_partner.id"
                                                :placeholder="dataSearch.email_partner.placeholder"
                                                :value-default="dataSearch.email_partner.value"
                                        ></InputTextNormal>
                                    </div>
                                </div>
                                <div class="col-sm-12 d-flex gap-5 flex-wrap">
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.phone_partner.label"
                                                :id="dataSearch.phone_partner.id"
                                                :placeholder="dataSearch.phone_partner.placeholder"
                                                :value-default="dataSearch.phone_partner.value"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <SelectNormal
                                                :label="dataSearch.priority_partner.label"
                                                :id="dataSearch.priority_partner.id"
                                                :placeholder="dataSearch.priority_partner.placeholder"
                                                :value-default="dataSearch.priority_partner.value"
                                                :options="dataSearch.priority_partner.options"
                                        ></SelectNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <SelectNormal
                                                :label="dataSearch.status_partner.label"
                                                :id="dataSearch.status_partner.id"
                                                :placeholder="dataSearch.status_partner.placeholder"
                                                :value-default="dataSearch.status_partner.value"
                                                :options="dataSearch.status_partner.options"
                                        ></SelectNormal>
                                    </div>
                                </div>
                            </div>
                            <div class="btn-action col-sm-1 d-flex flex-column justify-content-end">
                                <ButtonSearchComponent :label="labelButtonSearch" @click="searchPartners"></ButtonSearchComponent>
                            </div>
                        </div>
                    </div>
                    <div class="btn-invite-partner">
                        <ButtonAddComponent :label="labelButtonInvite" @click="redirectToInvite"></ButtonAddComponent>
                    </div>
                    <div class="col-sm-12">
                        <div class="col-sm-12 d-flex justify-content-between mt-4">
                            <div class="action d-flex align-items-center gap-3">
                                <div class="total">
                                    {{ CommonText.TOTAL_RECORD(listPartners.length, paginate.itemCount) }}
                                </div>
                                <div class="dropdown-action">
                                    <SelectCustom
                                            :label="selectAction.label"
                                            :id="selectAction.id"
                                            :placeholder="selectAction.placeholder"
                                            :value-default="selectAction.value"
                                            :required="selectAction.required"
                                            :options="selectAction.options"
                                            @action="actionSelect($event)"
                                    ></SelectCustom>
                                </div>
                            </div>
                            <div class="action-left d-flex align-items-center gap-3">
                                <div class="dropdown-action">
                                    <SelectCustom
                                            :label="selectLimitPage.label"
                                            :id="selectLimitPage.id"
                                            :placeholder="selectLimitPage.placeholder"
                                            :value-default="selectLimitPage.value"
                                            :required="selectLimitPage.required"
                                            :options="selectLimitPage.options"
                                            @action="actionLimitPage($event)"
                                    ></SelectCustom>
                                </div>
                            </div>
                        </div>
                        <div class="list-partners-component">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th scope="col" style="width: 2%;"><InputCheckboxOne id="select_all" :value-default="checkAll" @inputValue="onChangeSelectAll($event)" :checked="checkAll"></InputCheckboxOne></th>
                                    <th scope="col" v-for="(header, key) in dataHeaderTable" :key="header.order" :style="{ 'width': header.width }">
                                        {{header.label}}
                                        <span class="sort" v-if="header.sort !== undefined" @click="sortPartners(key)"><span><IconArrowDown :color="header.sort === 1 ? '#3a3a3a' : '#909090'"/></span><span style="margin-left: -10px;"><IconArrowUp :color="header.sort === 1 ? '#909090' : '#3a3a3a'"/></span></span>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-if="listPartners.length > 0" v-for="(partner, key) in listPartners" :key="partner.id">
                                    <td><InputCheckboxOne :id="partner.id" :value-default="checkItems[partner.id]" @inputValue="onChangeSelectItem($event, partner.id)" :checked="checkItems[partner.id]"></InputCheckboxOne></td>
                                    <td>{{partner.partner_name ?? ''}}</td>
                                    <td>{{partner.partner_code}}</td>
                                    <td>{{partner.partner_email}}</td>
                                    <td>{{partner.partner_tel}}</td>
                                    <td class="d-flex justify-content-center">
                                        <LabelPriority
                                            :label="CommonService.comparePriorityPartner(parseInt(partner.partner_priority))"
                                            :color="CommonService.comparePriorityPartnerColorText(parseInt(partner.partner_priority))"
                                            :background_color="CommonService.comparePriorityPartnerBackground(parseInt(partner.partner_priority))">
                                        </LabelPriority>
                                    </td>
                                    <td class="status">
                                        <LabelStatus
                                            :label="CommonService.compareStatusPartner(parseInt(partner.status))"
                                            :color="CommonService.compareStatusPartnerColorText(parseInt(partner.status))"
                                            :background_color="CommonService.compareStatusPartnerBackground(parseInt(partner.status))">
                                        </LabelStatus>
                                    </td>
                                </tr>
                                <tr v-else>
                                    <td colspan="7" class="text-center">Không có dữ lệu được tìm thấy!</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <PaginateComponent v-if="listPartners.length > 0 && paginate.pageCount > 1" :paginate="paginate" :urlOrigin="urlOrigin" @page="emitPage($event)"></PaginateComponent>
                </div>
            </div>
        </div>
    </div>
</div>
<ModalExportComponent
        @showModal="eventShowModalExport($event)"
        :eventClickShowModal="eventClickShowModalExport"
        :listItemSelected="listItemSelected"
        :location="location"
        :table="table"
></ModalExportComponent>
<LoadingComponent v-if="isLoading"></LoadingComponent>
